import { Roles } from "@shared/schemas/enums/roles";

const isUserSupport = (userType: Roles): boolean =>
	userType === Roles.USUARIO_SUPORTE;

const isUserAccountant = (userType: Roles): boolean =>
	userType === Roles.USUARIO_CONTADOR;

const isUserSupportOrAccountant = (userType: Roles): boolean =>
	userType === Roles.USUARIO_SUPORTE || userType === Roles.USUARIO_CONTADOR;

const isUserNormal = (userType: Roles): boolean =>
	userType === Roles.USUARIO_GRUPO;

export {
	isUserSupport,
	isUserAccountant,
	isUserSupportOrAccountant,
	isUserNormal
};
